import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Plus, ArrowRight, Globe } from "@phosphor-icons/react";

export default function Projects() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)).catch(() => {}); }, []);

  return (
    <Layout>
      <div className="mx-auto max-w-6xl px-6 py-10 sm:px-10">
        <div className="flex items-end justify-between">
          <h1 className="font-display text-4xl font-bold tracking-tight">Projects</h1>
          <Button onClick={() => navigate("/new")} className="rounded-full active:scale-95" data-testid="new-project-button"><Plus size={18} weight="bold" /> New project</Button>
        </div>
        <div className="mt-8 grid gap-4 md:grid-cols-2">
          {projects.map((p, i) => (
            <motion.button key={p.id} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              onClick={() => navigate(p.status === "live" ? `/projects/${p.id}` : `/projects/${p.id}/flow`)}
              data-testid={`project-card-${p.id}`}
              className="group flex items-center justify-between rounded-2xl border border-border bg-card p-6 text-left transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg">
              <div className="min-w-0">
                <div className="flex items-center gap-3"><h3 className="truncate font-display text-xl font-medium">{p.name}</h3><StatusBadge status={p.status} /></div>
                <p className="mt-2 text-sm text-muted-foreground">{p.deployment?.domain || p.analysis?.project_type || "Uploaded project"}</p>
              </div>
              <ArrowRight size={20} className="shrink-0 text-muted-foreground transition-transform duration-200 group-hover:translate-x-1" />
            </motion.button>
          ))}
          {projects.length === 0 && <p className="text-muted-foreground">No projects yet.</p>}
        </div>
      </div>
    </Layout>
  );
}
